import React, { useEffect } from "react"
import { navigate, graphql, useStaticQuery } from "gatsby"
import { locales } from "../../globals"
import SEO from "components/seo"
import { useContent } from "src/utils/hooks"

const Index = () => {
  const seoquery = useStaticQuery(graphql`
    query {
      chapter {
        pl {
          landing {
            seo {
              title {
                content
              }
              description {
                content
              }
              image {
                content
              }
            }
          }
        }
        en {
          landing {
            seo {
              title {
                content
              }
              description {
                content
              }
              image {
                content
              }
            }
          }
        }
        lt {
          landing {
            seo {
              title {
                content
              }
              description {
                content
              }
              image {
                content
              }
            }
          }
        }
      }
    }
  `)

  const { resolve } = useContent(seoquery)

  useEffect(() => {
    const storedLanguage = localStorage.getItem("language")
    if (!locales.includes(storedLanguage))
      localStorage.setItem("language", "PL")
    navigate(`/${localStorage.getItem("language").toLowerCase()}/`)
  }, [])

  //fix seo

  if (typeof window === "undefined")
    return (
      <SEO
        title={resolve(`CHAPTER_PL_LANDING_SEO_TITLE`)}
        lang="pl"
        description={resolve(`CHAPTER_PL_LANDING_SEO_DESCRIPTION`)}
      />
    )

  //

  if (
    typeof window !== "undefined" &&
    localStorage &&
    localStorage.getItem("language") === "PL"
  )
    return (
      <SEO
        title={resolve(`CHAPTER_PL_LANDING_SEO_TITLE`)}
        lang="pl"
        description={resolve(`CHAPTER_PL_LANDING_SEO_DESCRIPTION`)}
      />
    )
  if (
    typeof window !== "undefined" &&
    localStorage &&
    localStorage.getItem("language") === "EN"
  )
    return (
      <SEO
        title={resolve(`CHAPTER_EN_LANDING_SEO_TITLE`)}
        lang="en"
        description={resolve(`CHAPTER_EN_LANDING_SEO_DESCRIPTION`)}
      />
    )
  if (
    typeof window !== "undefined" &&
    localStorage &&
    localStorage.getItem("language") === "LT"
  )
    return (
      <SEO
        title={resolve(`CHAPTER_LT_LANDING_SEO_TITLE`)}
        lang="lt"
        description={resolve(`CHAPTER_LT_LANDING_SEO_DESCRIPTION`)}
      />
    )
  return null
}
export default Index
